module.exports = __webpack_public_path__ + "media/images/analytics_icons/analytic_assets_store5-52bef5012f6b771f45b3d84448ce910e.png";